import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.1\" clip-path=\"url(#i999939434__a)\"><path d=\"M7.917 8.75H2.084\"></path><path stroke=\"inherit\" d=\"M5 5 3.167 6.375A1.67 1.67 0 0 0 2.5 7.708v.625a.417.417 0 0 0 .417.417h4.166a.417.417 0 0 0 .417-.417v-.625a1.67 1.67 0 0 0-.667-1.333zM2.084 1.25h5.833M5 5l1.833-1.375A1.67 1.67 0 0 0 7.5 2.292v-.625a.417.417 0 0 0-.417-.417H2.917a.417.417 0 0 0-.417.417v.625a1.67 1.67 0 0 0 .667 1.333z\"></path></g><defs><clipPath id=\"i999939434__a\"><path fill=\"#fff\" d=\"M0 0h10v10H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }